<ng-container *ngIf="antwoordResultaat">
  <app-progress minText="Bijna niet" maxText="Bijna volledig" [max]='100' [value]='getAnswer()'>
  </app-progress>
</ng-container>
